import { MaxValidPhoneLength, MinValidPhoneLength } from '../../constants';

const validatePhoneNumber = (phoneNumber) => {
  const phoneLength = (phoneNumber || '').length;
  return phoneLength >= MinValidPhoneLength && phoneLength <= MaxValidPhoneLength;
};

export default validatePhoneNumber;
